import POSComponent from "components/POS/POSComponent";
import React from "react";
import "./styles.css";

const POSContainer = (props: any) => {
  return <POSComponent />;
};

export default POSContainer;
